import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Checkbox as AriaCheckbox, CheckboxProps } from "react-aria-components";

import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";

import { _CheckboxAsset } from "./_CheckboxAsset";
import { sharedStyles, useCardInputStyles } from "../../styles";
interface Props extends CheckboxProps {
  isCard?: boolean;
  noBorder?: boolean;
  strong?: boolean;
}

export function _Checkbox(props: Props) {
  const cardStyles = useCardInputStyles();
  const { noBorder, isCard, ...checkboxProps } = props;
  const className = css(
    styles.checkbox,
    isCard && cardStyles,
    isCard && sharedStyles.basicCard,
    noBorder && sharedStyles.noBorder
  );

  return (
    <AriaCheckbox {...mergeProps(checkboxProps, { className })}>
      {(renderProps) => {
        return (
          <>
            <_CheckboxAsset
              {...renderProps}
              isFocused={isCard ? false : renderProps.isFocused}
              isFocusVisible={isCard ? false : renderProps.isFocusVisible}
            />
            <div className={css(styles.text)}>
              {typeof props.children === "function"
                ? props.children(renderProps)
                : props.children}
            </div>
          </>
        );
      }}
    </AriaCheckbox>
  );
}

const styles = {
  checkbox: css(
    {
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      gap: "var(--space-2)",
      paddingBottom: "var(--space-1)",
      paddingTop: "var(--space-1)",
    },
    getTextStyle("form/body-secondary")
  ),
  text: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
};
